import React from "react";
import InfoLayout, { Sec } from "@/components/InfoLayout";

export default function Accessibility() {
  return (
    <InfoLayout title="Accessibility Statement" docTitle="Accessibility" subtitle="We aim to make CiteQR usable by everyone.">
      <Sec heading="Our commitment">
        <p>CiteQR follows WCAG 2.2 AA practices as a design goal. We continuously work to improve the accessibility of the platform.</p>
      </Sec>
      <Sec heading="What we do">
        <ul className="list-disc space-y-1 pl-5">
          <li>Keyboard-accessible navigation and visible focus indicators.</li>
          <li>Proper form labels and helpful, specific error messages.</li>
          <li>Sufficient color contrast and controls that do not rely on color alone.</li>
          <li>Semantic headings, descriptive page titles, and alt text for meaningful images.</li>
          <li>Screen-reader-friendly components built on accessible primitives.</li>
        </ul>
      </Sec>
      <Sec heading="QR code accessibility">
        <p>We warn when foreground and background colors lack sufficient contrast for reliable scanning, and we verify that each generated code can be decoded before download.</p>
      </Sec>
      <Sec heading="Feedback">
        <p>If you encounter an accessibility barrier, please tell us through the Contact &amp; Support page so we can address it.</p>
      </Sec>
    </InfoLayout>
  );
}
